import React from "react";
import ReactDOM from 'react-dom/client';
import "./index.css";
import "./i18n";
import App, { AppShell } from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { PersistGate } from "redux-persist/integration/react";
import { DndProvider } from "react-dnd"; // Import DndProvider
import { HTML5Backend } from "react-dnd-html5-backend"; // Import backend for drag and drop
import { installChunkLoadRecovery } from "./utils/chunkLoadRecovery";
import versionInfo, { APP_VERSION } from "./version";
import { installVersionGuard } from "./utils/versionGuard";

installChunkLoadRecovery();

// Canlida hangi surumun yuklu oldugunu konsoldan gormek icin.
// eslint-disable-next-line no-console
console.info(
  `%cRabo Frontend v${APP_VERSION}`,
  "color:#fff;background:#0a7cff;padding:2px 6px;border-radius:4px;font-weight:bold",
  versionInfo
);

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  persistedReducer,
  compose(applyMiddleware(thunk.withExtraArgument({})))
);
const persistor = persistStore(store);

export { store, persistor }; // Export store and persistor

// Backend ile surum uyumunu kontrol et (yalnizca super admin; store olustuktan sonra).
installVersionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={<AppShell />} persistor={persistor}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//////console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();